import React from "react";

import { Sorter } from "@impero-com/ui";
import { SortDirection } from "@tanstack/react-table";

interface SortableHeaderProps {
    title: string;
    canSort: boolean;
    isSorted: SortDirection | false;
    children?: React.ReactNode;
    className?: string;
}

/**
 * A reusable component for table headers that need custom sorting UI.
 * This component handles its own sorter display and layout.
 */
export function SortableHeader({
    title,
    canSort,
    isSorted,
    children,
    className,
}: SortableHeaderProps) {
    return (
        <div className={className}>
            <div className={className}>
                <span>{title}</span>
                {canSort && isSorted !== undefined && (
                    <Sorter sortDirection={isSorted} />
                )}
            </div>
            {children}
        </div>
    );
}
